'use client';
import Nav from '@/components/Nav';
import { useTranslation } from '@/lib/i18n';

export default function AITutorPage() {
  const { t } = useTranslation();
  return (
    <div>
      <Nav />
      <main className='mx-auto max-w-4xl p-8'>
        <h1 className='text-3xl font-bold'>{t('aiTutor.title')}</h1>
        <p className='mt-2 opacity-70'>{t('aiTutor.subtitle')}</p>
        <div className='mt-8 rounded border border-border p-8 text-center'>
          <p className='text-lg opacity-60'>{t('common.connectedToApi')}</p>
        </div>
      </main>
    </div>
  );
}
